import { getText, getTextForOwner } from '../api/textListApi';
import type { TextWithTextBlockAndRelatedProjectData } from '../dto/EntityRepository';
import { useTextViewStore } from '../store/TextViewStore';
import { useOpenFromHash } from './useOpenFromHash';

/** `/@handle/texts#textId` */
export const useTextFromHash = () => {
  const activeTextId = useTextViewStore((s) => s.activeText?.id ?? null);

  useOpenFromHash({
    activeId: activeTextId,
    getActiveId: () => useTextViewStore.getState().activeText?.id ?? null,
    request: (aui, id, isOwner) =>
      isOwner ? getTextForOwner(aui, id) : getText(id),
    isInaccessible: (data, isOwner) => !isOwner && !data.isPublic,
    open: publishText,
  });
};

const publishText = (data: TextWithTextBlockAndRelatedProjectData) => {
  const { textBlockList, relatedProjectList, ...text } = data;
  const store = useTextViewStore.getState();
  store.setActiveText(text);
  store.setActiveTextBlockList(textBlockList);
  store.setActiveRelatedProjectList(relatedProjectList);
};
